import { SET_MATRIKULATU } from 'volto-ueu/actions';
const initialState = {
  error: null,
  matrikulatu: [],
  loaded: false,
  loading: false,
  message: '',
};

/**
 * Matrikulatu reducer.
 * @function matrikulatu
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export const matrikulatuReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${SET_MATRIKULATU}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        matrikulatu: [],
      };
    case `${SET_MATRIKULATU}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        matrikulatu: action.result,
        message: 'Matrikulazioa ondo burutu da',
      };
    case `${SET_MATRIKULATU}_FAIL`:
      return {
        ...state,
        error: true,
        loaded: false,
        loading: false,
        message: action?.error?.response?.body?.error,
      };
    default:
      return state;
  }
};
